// extracted by mini-css-extract-plugin
export default {"ContentMenu":"index__ContentMenu--4lSM4","contentMenu":"index__ContentMenu--4lSM4"};